// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-wrapper{position:relative;width:100%;padding-top:32px;padding-bottom:32px}@media(min-width:640px){.block-wrapper{padding-top:calc(8vw - 19.2px);padding-bottom:calc(8vw - 19.2px)}}@media(min-width:1440px){.block-wrapper{padding-top:96px;padding-bottom:96px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
